var React = require('react');

function Copyright (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:#d7d3d1;}")),React.createElement("path",{"d":"M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216ZM96,128a32,32,0,0,0,57.6,19.2,8,8,0,0,1,12.8,9.61,48,48,0,1,1,0-57.62,8,8,0,0,1-12.8,9.61A32,32,0,0,0,96,128Z","fill":"currentColor","key":1})]);
}

Copyright.defaultProps = {"width":"100%","height":"100%","aria-labelledby":"copyright icon","fill":"currentColor","viewBox":"0 0 256 256"};

module.exports = Copyright;

Copyright.default = Copyright;
